import { useState, useCallback } from 'react';

import { useSmartTranslations } from '@core/js/hooks/i18n';
import { usePageInfoFetch } from '@core/js/components/system/Page/hocs/withCommonPage/hooks';
import { useIsPageInPopupUrl } from '@core/js/components/system/Page/hooks';

export const useMobileRegistrationHeader = () => {
    const getIsPageInPopupUrl = useIsPageInPopupUrl();
    const path = window.location.pathname;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [{ page }] = usePageInfoFetch({ path, isPageInPopup: getIsPageInPopupUrl() }) as any;
    const { title = '' } = page || {};
    const registerTitle = title && title.split('-')[0].trim();
    const t = useSmartTranslations();

    const [isImgLoading, setImgLoad] = useState(true);
    const onLoad = useCallback(() => {
        setImgLoad(false);
    }, []);

    return {
        isImgLoading,
        onLoad,
        registerTitle: t(registerTitle)
    };
};
